import { render, staticRenderFns } from "./fansAside.vue?vue&type=template&id=9f12d850&scoped=true&"
import script from "./fansAside.vue?vue&type=script&lang=js&"
export * from "./fansAside.vue?vue&type=script&lang=js&"
import style0 from "./fansAside.vue?vue&type=style&index=0&id=9f12d850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f12d850",
  null
  
)

export default component.exports